import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { DomSanitizer } from '@angular/platform-browser';
import { environment } from '../../../environments/environment';

@Injectable()
export class ContaCorrenteService {

  getContaCorrentes(): Observable<HttpResponse<any>> {
    return this.http.get(
      environment.webApiSaguiControlUrl + '/api/contacorrente/visualizatodas/', { observe: 'response' })
  }

  getStatusIntegracao(bancoId:any, empresaId:any): Observable<HttpResponse<any>> {

    const params = {
      id: bancoId,
      empresaId: empresaId,
    }

    return this.http.get(
      environment.webApiSaguiControlUrl + '/api/contacorrente/statusintegracao' , { observe: 'response', params })
  }

  getContaCorrente(itemId: any): Observable<HttpResponse<any>> {
    return this.http.get(
      environment.webApiSaguiControlUrl + '/api/contacorrente/visualiza/' + itemId, { observe: 'response' })
  }

  postContaCorrente(item: any): Observable<HttpResponse<any>> {
    return this.http.post(
      environment.webApiSaguiControlUrl + '/api/contacorrente/inclui/', item, { observe: 'response' })
  };

  putContaCorrente(item: any, itemId: any): Observable<HttpResponse<any>> {
    return this.http.put(
      environment.webApiSaguiControlUrl + '/api/contacorrente/atualiza/' + itemId, item, { observe: 'response' })
  };

  deleteContaCorrente(itemId: any): Observable<HttpResponse<any>> {
    return this.http.delete(
      environment.webApiSaguiControlUrl + '/api/contacorrente/exclui/' + itemId, { observe: 'response' })
  }

  getEmpresas(): Observable<HttpResponse<any>> {
    return this.http.get(
      environment.webApiSaguiControlUrl + '/api/contacorrente/visualizatodasempresas', { observe: 'response' })
  }

  getBancos(): Observable<HttpResponse<any>> {
    return this.http.get(
      environment.webApiSaguiControlUrl + '/api/banco/visualizatodas', { observe: 'response' })
  }

  postContaCorrenteRemessas(item: any): Observable<HttpResponse<any>> {
    return this.http.post(
      environment.webApiSaguiControlUrl + '/api/contacorrente/visualizaremessas/', item, { observe: 'response' })
  };

  postContaCorrenteGerarRemessa(item: any): Observable<HttpResponse<any>> {
    return this.http.post(
      environment.webApiSaguiControlUrl + '/api/contacorrente/geraremessa/', item, { observe: 'response' })
  };

  postContaCorrenteRetornos(item: any): Observable<HttpResponse<any>> {
    return this.http.post(
      environment.webApiSaguiControlUrl + '/api/contacorrente/visualizaarquivos/', item, { observe: 'response' })
  };

  postContaCorrenteRetornoImportar(item: any): Observable<HttpResponse<any>> {
    return this.http.post(
      environment.webApiSaguiControlUrl + '/api/contacorrente/arquivoretorno/', item, { observe: 'response' })
  };

  getContaCorrenteRetornoLog(itemId: any): Observable<HttpResponse<any>> {
    return this.http.get(
      environment.webApiSaguiControlUrl + '/api/contacorrentearquivoretorno/visualiza/' + itemId, { observe: 'response' })
  }

  constructor(private http: HttpClient, private sanitizer: DomSanitizer) {

  }
}
